import React from 'react';
import { priceHintIcon, BestPriceIcon, bestPricePlate, PlateContainer } from './styles';
import { css } from 'linaria';
import { useTranslation } from 'react-i18next';

export const ProductBestPriceNameplate = () => {
  const {t} = useTranslation()
  return (
    <PlateContainer className={bestPricePlate}  data-qa="product-best-price-nameplate">
      <BestPriceIcon className={priceHintIcon}>
        <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g clipPath="url(#clip0_1041_156)">
            <path d="M0 5.09961L4.32418 8.2569L5.34534 5.09961H0Z" fill="#FDC300"/>
            <path d="M2.67241 13.3639L7.0029 10.2066L4.32392 8.25781L2.67241 13.3639Z" fill="#FDC300"/>
            <path d="M5.34539 5.09961L3.45435 7.62417L4.32423 8.2569L5.34539 5.09961Z" fill="#FDC300"/>
            <path d="M7.00316 10.2066L3.99638 9.28283L4.32418 8.25781L7.00316 10.2066Z" fill="#FDC300"/>
            <path d="M9.67576 8.2569L13.9999 5.09961H8.6546L9.71989 8.3961L9.67576 8.2569Z" fill="#FDC300"/>
            <path
              d="M8.65469 5.09977L7.4255 1.31607L8.65469 5.09977L7.00318 0L5.34536 5.09977L4.3242 8.25705L7.00318 10.2058L11.3274 13.3631L9.71998 8.39625L8.65469 5.09977Z"
              fill="#FDC300"/>
          </g>
          <defs>
            <clipPath id="clip0_1041_156">
              <rect width="14" height="14" fill="white"/>
            </clipPath>
          </defs>
        </svg>
      </BestPriceIcon>
      <span>{t('product-card.best-price')}</span>
    </PlateContainer>
  );
};

const bestPriceNameplateContainer = css`
  display: flex;
  gap: var(--space-75);
  margin-bottom: var(--space-75);
`;

const textStyle = css`
  margin-top: auto;
  margin-bottom: auto;
`;